<div [class]="'object-search' + (data ? ' object-search--content' : '')">
  <div class="object-search__frame">
    @if (layoutItem.search?.showTitle) {
      <h3 class="object-search__title">{{ layoutItem.label }}</h3>
    }

    <div class="object-search__search">
      <input type="text" #searchInput class="search__input" autocomplete="off"
        [placeholder]="layoutItem.label" (keyup)="onFilter()">
      <svg class="icon">
        <use xlink:href="/assets/sprites.svg#icon-search"></use>
      </svg>
    </div>

    @if (data) {
      <div class="object-search__results">
        @for (dataObject of data; track dataObject) {
          <a class="object-search__result"
            (click)="selectDataObject(dataObject._links._self.href)" href="javascript:void(0)">
            {{ dataObject.name }}
          </a>
        }
        @if (links.prev) {
          <input type="button" class="btn" value="prev" (click)="navigate(links.prev)">
        }
        @if (links.next) {
          <input type="button" class="btn" value="next" (click)="navigate(links.next)">
        }
      </div>
    }
  </div>
</div>